import { getShortText } from "../../utils/util";
import { useTranslation } from "react-i18next";
import ClayProgressBar from "@clayui/progress-bar";

const InProgressCoursesSectionCard = ({ item }) => {
	const { t } = useTranslation();

	return (
		<div className="card-wrapper">
			<div className="tag-course">{t("course")}</div>
			<a href={`/course/${item.firstLessonFriendlyUrlPath}`} className="card-link">
				<div className="card-container d-flex learn-education__landing-card">
					<div className="card-content-container d-flex flex-column justify-content-between w-100">
						<h3>{item.title}</h3>
						<div className="card-description">
							{getShortText(item.description)}
						</div>
						<ClayProgressBar value={item.courseProgress} className="mt-3" />
					</div>
				</div>
			</a>
		</div>
	);
};

export default InProgressCoursesSectionCard;
